import React from 'react';
import { Table, Button } from 'react-bootstrap';
import { formatPrice } from '../../../../shared/utils/formatPrice';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { BookingResponse, BookingResponseData } from '../../../../services/sales-report/response/BookingResponse';

interface SalesTableReportProps {
    data: BookingResponse;
}

const SalesTableReport: React.FC<SalesTableReportProps> = ({ data }) => {
    console.log("SalesTableReport data:", data);
    const columnsReservations = [
        { label: "Property", key: "property_name" },
        { label: "Booking Date", key: "invoice_date" },
        { label: "Source", key: "source" },
        { label: "Voucher Number", key: "voucher_number" },
        { label: "Reservation Number", key: "invoice_number" },
        { label: "Room Type", key: "room_type_name" },
        { label: "Room Number", key: "room_number" },
        { label: "Guest Details", key: "customer_name" },
        { label: "Phone", key: "customer_phone" },
        { label: "Country", key: "customer_country" },
        { label: "Promo Code", key: "promo_code" },
        { label: "Check-In", key: "checkin_date" },
        { label: "Check-Out", key: "checkout_date" },
        { label: "Nights", key: "night" },
        { label: "Total (IDR)", key: "rates" },
        { label: "Room Only (IDR)", key: "rates" }
    ];

    // Export to PDF
    const exportToPDF = () => {
        const doc = new jsPDF();
        doc.text("Sales Report", 14, 10);

        const tableData = data.data.map(row => columnsReservations.map(col => {
            if (col.key === 'rates' || col.key === 'room_only') {
                return formatPrice(Number(row[col.key as keyof BookingResponseData]));
            }
            return row[col.key as keyof BookingResponseData] || '-';
        }));

        autoTable(doc, {
            head: [columnsReservations.map(col => col.label)],
            body: tableData,
        });

        doc.save("SalesReport.pdf");
    };

    // Export to Excel
    const exportToExcel = () => {
        const wsData = [
            columnsReservations.map(col => col.label),
            ...data.data.map(row => columnsReservations.map(col => {
                if (col.key === 'rates' || col.key === 'room_only') {
                    return formatPrice(Number(row[col.key as keyof BookingResponseData]));
                }
                return row[col.key as keyof BookingResponseData] || '-';
            })),
            [
                "Total", "", "", "", "", "", "", "", "", "", "", "", "", "",
                formatPrice(parseFloat(String(data.total))),
                formatPrice(parseFloat(String(data.total)))
            ]
        ];

        const ws = XLSX.utils.aoa_to_sheet(wsData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Report");
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(dataBlob, "SalesReport.xlsx");
    };

    const formatCellValue = (row: BookingResponseData, key: string) => {
        const value = row[key as keyof BookingResponseData];

        if (key === 'rates' || key === 'room_only') {
            return formatPrice(parseFloat(value as string) || 0);
        }

        return value || '-';
    };

    return (
        <div className="mt-4">
            <div className="mb-3 d-flex gap-2">
                <Button variant="primary" onClick={exportToPDF}>Export to PDF</Button>
                <Button variant="success" onClick={exportToExcel}>Export to Excel</Button>
            </div>

            <div className="table-responsive">
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            {columnsReservations.map((col, index) => (
                                <th key={index}>{col.label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data && data.data.length > 0 ? (
                            [...data.data]
                                .sort((a, b) => new Date(a.checkin_date).getTime() - new Date(b.checkin_date).getTime())
                                .map((row, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {columnsReservations.map((col, colIndex) => (
                                            <td key={colIndex}>
                                                {col.key === 'rates' || col.key === 'room_only'
                                                    ? formatCellValue(row, col.key)
                                                    : row[col.key as keyof BookingResponseData] || '-'}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                        ) : (
                            <tr>
                                <td colSpan={columnsReservations.length} className="text-center">
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={14}><strong>Total</strong></td>
                            <td><strong>{formatPrice(parseFloat(String(data.total)) || 0)}</strong></td>
                            <td><strong>{formatPrice(parseFloat(String(data.total)) || 0)}</strong></td>

                        </tr>
                    </tfoot>
                </Table>
            </div>
        </div>
    );
};

export default SalesTableReport;